"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noBignumber = noBignumber;
exports.noFraction = noFraction;
exports.noMatrix = noMatrix;
exports.noIndex = noIndex;
exports.noSubset = noSubset;

function noBignumber() {
  throw new Error('No "bignumber" implementation available');
}

function noFraction() {
  throw new Error('No "fraction" implementation available');
}

function noMatrix() {
  throw new Error('No "matrix" implementation available');
}

function noIndex() {
  throw new Error('No "index" implementation available');
}

function noSubset() {
  throw new Error('No "matrix" implementation available');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/utils/noop.js
// module id = q2v0
// module chunks = 23